import { makeStyles } from '@material-ui/core/styles';
import { Checkbox, Chip, List, ListItem, ListItemIcon, ListItemText, Paper, Typography } from "@material-ui/core";
import _ from 'lodash';
import { useTranslation } from "react-i18next";
import { Done } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexDirection: 'column',
    },
    chips: {
        display: 'flex',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(0.5),
        },
    },
  }));

const weightDef = [
    {
        name: "mini_parcel",
        minWeight: 0,
        maxWeight: 3 
    }, {
        name: "small_parcel",
        minWeight: 3,
        maxWeight: 5 
    }, {
        name: "medium_parcel",
        minWeight: 5,
        maxWeight: 10
    }, {
        name: "large_parcel",
        minWeight: 10,
        // maxWeight: null //null = no limit
        maxWeight: Number.MAX_SAFE_INTEGER
    }
]

function OrderFilter(props){
    const classes = useStyles();
    const {t} = useTranslation('parcelStatus');
    let {pathCodes, filter, handleParcelFilterChange} = props

    return (
        <div className={classes.root}>
            <Typography>{t('mapManagement:tracking_status')}</Typography>
            <div className={classes.chips}>
                {_.map(pathCodes, (code, index)=>{
                    let parcelStatusIndex = _.indexOf(filter.parcelStatus, code)
                    return (
                        <Chip
                            key={index}
                            label={t(code)}
                            color={parcelStatusIndex !== -1 ?  "secondary" : "default"}
                            icon={parcelStatusIndex !== -1 ? <Done />: null}
                            clickable={true}
                            onClick={()=>handleParcelFilterChange({parcelStatus: code})}
                        />
                    )
                })}
            </div>
            <Typography>{t('common:weight')}</Typography>
            <div className={classes.chips}>
                {_.map(weightDef, (weight, index)=>{
                    let parcelWeightIndex = _.findIndex(filter.parcelWeight, ['name', weight.name])
                    return (
                        <Chip
                            key={index}
                            label={t("mapManagement:"+weight.name)}
                            color={parcelWeightIndex !== -1 ?  "secondary" : "default"}
                            icon={parcelWeightIndex !== -1 ? <Done />: null}
                            clickable={true}
                            onClick={()=>handleParcelFilterChange({parcelWeight: weight})}
                        />
                    )
                })}
            </div>
            
            {/* <Paper variant='outlined' style={{width: '45%', height: '100%', overflowY: 'auto'}}>
                <List dense component="div" role="list">
                    {_.map(pathCodes, (code, index) =>{
                        return (
                            <ListItem key={index} role="listitem" button >
                                <ListItemIcon>
                                    <Checkbox
                                        edge="start"
                                    />
                                </ListItemIcon>
                                <ListItemText primary={t(code)}/>
                            </ListItem>
                        )
                    })}
                </List>
            </Paper> */}
        </div>
    )
}

OrderFilter.defaultProps = {
    filter: {}
}

export default OrderFilter